export default "__VITE_ASSET__CyiHlJdy__"